import axios from 'axios';
import dayjs from 'dayjs';

import { API_ENDPOINTS } from 'Constants';

export interface AddStandbyRequestDto {
	name: string;
	phone: string;
	email: string;
	ferryTripIds: string[];
	userId: string | null;
	/** Added from check-in. Only labels the trip history row. */
	inCheckIn?: boolean;
}

interface AddStandbyResult {
	code: 'None' | 'StandbyMaxCountExceeded';
	message?: string;
}

export const addStandby = async (request: AddStandbyRequestDto) => {
	const result = await axios.post<AddStandbyResult>(API_ENDPOINTS.STANDBY.POST_ADD, request);
	return result.data;
};

export interface StandbyItemDto {
	id: string;
	created: Date;
	name: string;
	email: string;
	phone: string;
	userId?: string;
	/** Only ever true when the list was asked for with `includeRemoved`. */
	removed: boolean;
	removedAt?: Date;
	/** Null when the removal has no recorded user, or that user has since been deleted. */
	removedByName?: string | null;
}

/**
 * The trip's standby list, oldest first. `includeRemoved` adds the entries staff have taken off, for the
 * trip's Waitlist / Standby tab; check-in wants the live list only.
 */
export const getStandbyList = async (ferryTripId: string, includeRemoved = false) => {
	const result = await axios.get<StandbyItemDto[]>(API_ENDPOINTS.STANDBY.GET_LIST(ferryTripId, includeRemoved));
	return result.data.map(x => {
		return {
			...x,
			created: dayjs(x.created).toDate(),
			removedAt: x.removedAt ? dayjs(x.removedAt).toDate() : undefined,
		};
	});
};

/** `inCheckIn` only labels the trip history row as done at check-in. */
export const removeStandby = async (id: string, inCheckIn = false) => {
	await axios.delete(API_ENDPOINTS.STANDBY.DELETE(id), { params: inCheckIn ? { inCheckIn } : undefined });
};

/** How many times the signed-in user is already on standby for these trips. Removed entries do not count. */
export const getMyStandbyCount = async (ferryTripIds: string[]) => {
	const result = await axios.get<{ count: number }>(API_ENDPOINTS.STANDBY.GET_MY_COUNT(ferryTripIds));
	return result.data.count;
};
